module.exports = __webpack_public_path__ + "static/media/FO.fd474191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/FO.svg
// module id = 2153
// module chunks = 7